module.exports = __webpack_public_path__ + "img/single.6e09024d.svg";